import { AuthField, AuthInput, AuthLabel } from '../../authModal.styles';
import { AUTH_STEPS } from '../constants/authForm.constants';

const AuthEmailField = ({
	email,
	onEmailChange,
	currentStep,
	isCheckEmailLoading,
	isAuthPending,
	isAuthSuccess,
	translations,
}) => (
	<AuthField>
		<AuthLabel htmlFor="auth-email">
			{translations.emailLabel || 'Email Address'}
		</AuthLabel>
		<AuthInput
			id="auth-email"
			type="email"
			placeholder={translations.emailPlaceholder || 'enter your email'}
			value={email}
			onChange={(event) => onEmailChange(event.target.value)}
			required
			disabled={
				currentStep !== AUTH_STEPS.EMAIL
				|| isCheckEmailLoading
				|| isAuthPending
				|| isAuthSuccess
			}
		/>
	</AuthField>
);

export default AuthEmailField;
